// src/pages/PostcodeQuote.jsx
import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
//import { LoadScript } from "@react-google-maps/api";
import axios from "axios";
import PostcodeInput from "../components/PostcodeInput";
import BookingForm from "../components/BookingForm";
import { fareClientRules } from "../config/fareClientRules";
import api from "../utils/api"; // adjust path if nee



// eslint-disable-next-line no-unused-vars
//const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

/*/const PostcodeQuote = () => {*/
const PostcodeQuote = ({ presetPickup = "", presetDropoff = "" }) => {

  /*const [fromPostcode, setFromPostcode] = useState("");*/
  const [fromPostcode, setFromPostcode] = useState(presetPickup);
  const [toPostcode, setToPostcode] = useState(presetDropoff);
  /*const [toPostcode, setToPostcode] = useState("");*/
  useEffect(() => setFromPostcode(presetPickup), [presetPickup]);
  useEffect(() => setToPostcode(presetDropoff), [presetDropoff]);
  const [distance, setDistance] = useState(null);
  const [fare, setFare] = useState(null);
  const [vehicleLabel, setVehicleLabel] = useState(null);
  const [vehicleType, setVehicleType] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [errors, setErrors] = useState({});
  const [loadingQuote, setLoadingQuote] = useState(false);
  const [quoteId, setQuoteId] = useState(null);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    datetime: "",
    vehicle: "",
    passengers: "",
    bags: "",
    notes: "",
    flight_number: "",
    pickup_time: "",
  });



// Apply presets immediately to override any saved values
useEffect(() => {
  if (presetPickup) setFromPostcode(presetPickup);
}, [presetPickup]);

useEffect(() => {
  if (presetDropoff) setToPostcode(presetDropoff);
}, [presetDropoff]);




  /* ---------------------------------------------------------------------- */
  /* 🚗 Dynamic max passengers & bags limits                                */
  /* ---------------------------------------------------------------------- */
  const getMaxPassengers = () => {
    if (fareClientRules.enable14Seater) return fareClientRules.baseLimits.minibus14.passengers;
    if (fareClientRules.enable9Seater) return fareClientRules.baseLimits.minibus.passengers;
    if (fareClientRules.enable7Seater) return fareClientRules.baseLimits.mpv.passengers;
    return fareClientRules.baseLimits.saloon.passengers;
  };
  const getMaxBags = () => {
    if (fareClientRules.enable14Seater) return fareClientRules.baseLimits.minibus14.bags;
    if (fareClientRules.enable9Seater) return fareClientRules.baseLimits.minibus.bags;
    if (fareClientRules.enable7Seater) return fareClientRules.baseLimits.mpv.bags;
    return fareClientRules.baseLimits.saloon.bags;
  };
  const maxPassengers = getMaxPassengers();
  const maxBags = getMaxBags();

  const [pickupTime, setPickupTime] = useState(
    new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().slice(0, 16)
  );

  /* ---------------------------------------------------------------------- */
  /* 💾 Restore saved quote + form data (if exists)                         */
  /* ---------------------------------------------------------------------- */


/* ---------------------------------------------------------------------- */
/* 💾 Restore saved quote (if exists)                                     */
/* ---------------------------------------------------------------------- */

// 🚫 Do NOT restore saved quote when preset route is active

// 🚫 NEVER restore saved quote when using preset SEO routes
useEffect(() => {
  if (presetPickup || presetDropoff) {
    console.log("Preset route active → skip localStorage restore");
    return;
  }

  const saved = localStorage.getItem("lastQuote");
  if (!saved) return;

  try {
    const q = JSON.parse(saved);
    setFromPostcode(q.pickup || "");
    setToPostcode(q.dropoff || "");
    setFormData((prev) => ({
      ...prev,
      passengers: q.passengers || "",
      bags: q.bags || "",
    }));
    setPickupTime(q.pickup_time || "");
    setFare(q.fare || null);
    setDistance(q.distance || null);
    setVehicleType(q.vehicleType || null);
    setVehicleLabel(q.vehicleLabel || null);
    setQuoteId(q.quote_id || null);
    if (q.fare && q.distance) setShowForm(true);
  } catch (e) {
    console.warn("⚠ Restore failed", e);
  }
}, [presetPickup, presetDropoff]);



/* ---------------------------------------------------------------------- */
/* 💾 Auto-save latest quote + key info                                   */
/* ---------------------------------------------------------------------- */
// 🚫 Do NOT auto-save when using preset SEO pages
useEffect(() => {
  if (presetPickup || presetDropoff) {
    // console.log("Preset route active → skip auto-save");
    return;
  }

  // Only save if at least pickup/dropoff are filled
  if (!fromPostcode && !toPostcode) return;

  const payload = {
    pickup: fromPostcode,
    dropoff: toPostcode,
    passengers: formData.passengers,
    bags: formData.bags,
    pickup_time: pickupTime,
    fare,
    distance,
    vehicleType,
    vehicleLabel,
    quote_id: quoteId,
  };

  localStorage.setItem("lastQuote", JSON.stringify(payload));
}, [
  presetPickup,
  presetDropoff,
  fromPostcode,
  toPostcode,
  formData.passengers,
  formData.bags,
  pickupTime,
  fare,
  distance,
  vehicleType,
  vehicleLabel,
  quoteId,
]);


  /* ---------------------------------------------------------------------- */
  /* 💷 Fetch fare quote                                                    */
  /* ---------------------------------------------------------------------- */


/* ---------------------------------------------------------------------- */
/* 💷 Fetch fare quote                                                    */
/* ---------------------------------------------------------------------- */
const getDistance = async () => {
  // ✅ Basic form validations
  if (!fromPostcode.trim() || !toPostcode.trim()) {
    setErrors({ quote: "Please select both pickup and drop-off addresses." });
    return;
  }

  if (fromPostcode.trim().length < 3 || toPostcode.trim().length < 3) {
    setErrors({
      quote:
        "Please enter full pickup and drop-off addresses (minimum 3 characters each).",
    });
    return;
  }

  if (formData.passengers === "" || formData.passengers == null) {
    setErrors({ quote: "Please enter number of passengers." });
    return;
  }



if (formData.bags === "" || formData.bags === null || isNaN(Number(formData.bags))) {
  setErrors({ quote: "Please enter number of bags (use 0 if none)." });
  return;
}




  setLoadingQuote(true);
  setErrors({});




  // 🧪 Local test-mode mock (instant fare without API)
  const MOCK_ROUTES = {
    "SL1 2LT:SL1 2LL": { fare: 6.5, distance: 3.4, vehicleLabel: "Saloon" },
    "SL1 5JS:SL1 2LT": { fare: 7.2, distance: 4.1, vehicleLabel: "Saloon" },
  };

  const key = `${fromPostcode.trim().toUpperCase()}:${toPostcode.trim().toUpperCase()}`;
  if (MOCK_ROUTES[key]) {
    console.log("⚙️ Using frontend mock fare for test route");
    setDistance(MOCK_ROUTES[key].distance);
    setFare(MOCK_ROUTES[key].fare);
    setVehicleLabel(MOCK_ROUTES[key].vehicleLabel);
    setVehicleType("saloon");
    setShowForm(true);
    return;
  }






  try {
    const res = await api.post("/api/get-quote", {
      pickup: fromPostcode,
      dropoff: toPostcode,
      passengers: parseInt(formData.passengers, 10),
      bags: parseInt(formData.bags, 10),
      pickup_time: pickupTime,
    });

    // ✅ If fare is successfully returned
    if (res.data && res.data.fare) {
      setDistance(res.data.distance);
      setFare(res.data.fare);
      setVehicleLabel(res.data.vehicleLabel || null);
      setVehicleType(res.data.vehicleType || null);
      setFormData((prev) => ({
        ...prev,
        vehicle: res.data.vehicleType || "",
      }));
      setQuoteId(res.data.quote_id || null);
      setShowForm(true);
      return;
    }

    // ✅ If backend says it's a coming soon area
    if (res.data && res.data.comingSoon) {
      setErrors({
        quote:
          "🚧 Sorry, we’re not yet operating full coverage for this route.<br/>" +
          "We’re expanding rapidly — please check back soon or try another nearby pickup area. 🚖",
      });
      return;
    }

    // ✅ If backend sent explicit error (400 or handled rejection)
    if (res.data && res.data.error) {
      setErrors({
        quote: `⚠️ ${res.data.error}`,
      });
      return;
    }

    // ✅ Generic fallback
    setErrors({
      quote:
        "We’re temporarily unable to calculate a fare for this route.<br/>" +
        "Please verify your pickup and drop-off details or try again shortly.",
    });
  } catch (err) {
    console.error("❌ Error fetching fare:", err);
    setErrors({
      quote:
        err.response?.data?.error ||
        "⚠️ Our system is temporarily busy. Please try again in a few moments.",
    });
  } finally {
    setLoadingQuote(false);
  }
};




  /* ---------------------------------------------------------------------- */
  /* 🧾 Booking Form Handlers                                               */
  /* ---------------------------------------------------------------------- */
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  /* ---------------------------------------------------------------------- */
  /* 🧩 Validate booking before submit                                      */
  /* ---------------------------------------------------------------------- */
  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim() || formData.name.length < 3) {
      newErrors.name = "Please enter your full name.";
    }
    if (!formData.phone?.trim() || !/^\+?\d{10,15}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid phone number (10-15 digits).";
    }
    if (!formData.email?.trim() || !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Enter a valid email address.";
    }
    if (formData.flight_number?.trim() && !/^[A-Za-z]{2,3}\d{1,4}$/.test(formData.flight_number.trim())) {
      newErrors.flight_number = "Enter a valid flight number (e.g. BA1234)";
    }
    return newErrors;
  };

  /* ---------------------------------------------------------------------- */
  /* 📩 Submit booking                                                     */
  /* ---------------------------------------------------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await api.post("/api/bookings", {
        ...formData,
        pickup_location: fromPostcode,
        dropoff_location: toPostcode,
        pickup_time: pickupTime,
        fare: fare,
        quote_id: quoteId || null,
      });

      console.log("📦 Booking submission payload:", { ...formData, quoteId });

      if ((response.status === 200 || response.status === 201) && response.data.ref_code) {
        localStorage.removeItem("lastQuote"); // ✅ clear saved quote on successful booking
        window.location.assign(response.data.paymentLink);
      } else {
        alert("Booking saved but unable to redirect. Please contact support.");
      }
    } catch (error) {
      console.error("Error submitting booking:", error);
      if (error.response?.data?.error) {
        if (error.response.data.error.includes("email")) {
          setErrors((prev) => ({ ...prev, email: error.response.data.error }));
        } else {
          setErrors((prev) => ({ ...prev, form: error.response.data.error }));
        }
      } else {
        setErrors((prev) => ({ ...prev, form: "Error submitting booking. Please try again." }));
      }
    }
  };

  /* ---------------------------------------------------------------------- */
  /* 🖼️ UI                                                                */
  /* ---------------------------------------------------------------------- */
  return (
/*    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY} libraries={["places"]}> */

      <div
        id="taxi-quote-form"
        style={{
          maxWidth: "750px",
          width: "95%",
          margin: "2rem auto",
          padding: "2.5rem",
          backgroundColor: "#fff",
          borderRadius: "12px",
          boxShadow: "0 6px 18px rgba(0,0,0,0.15)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "1.8rem",
            color: "#222",
            fontSize: "26px",
            fontWeight: "700",
          }}
        >
          🚖 Get Your Taxi Fare
        </h2>

        {/* Clear saved quote button */}
        <div style={{ textAlign: "right", marginBottom: "10px" }}>
          <button
            style={{
              fontSize: "0.85rem",
              background: "#eee",
              border: "none",
              borderRadius: "6px",
              padding: "6px 10px",
              cursor: "pointer",
              color: "#333",
            }}
            onClick={() => {
              localStorage.removeItem("lastQuote");
              window.location.reload();
            }}
          >
            🗑 Clear & Start New Quote
          </button>
        </div>

        {/* existing form untouched */}
        {/* ...everything below remains as your current code (inputs, quote button, booking form, etc.) */}






        {/* Pickup Input */}
        <PostcodeInput
          placeholder="Pickup Location"
          value={fromPostcode}
          onChange={setFromPostcode}
          onPlaceSelected={(place) => setFromPostcode(place.formatted_address)}
          restrictions={{ country: "uk" }}
        />

        {/* Drop-off Input */}
        <PostcodeInput
          placeholder="Drop-off Location"
          value={toPostcode}
          onChange={setToPostcode}
          onPlaceSelected={(place) => setToPostcode(place.formatted_address)}
          restrictions={{ country: "uk" }}
        />



        {/* Passengers */}
        <label>Passengers</label>
        <input
          type="number"
          name="passengers"
          placeholder={`Passengers (max ${maxPassengers})`}
          min="1"
          max={maxPassengers}
          value={formData.passengers}
          onChange={(e) => {
            const val = Math.min(Number(e.target.value), maxPassengers);
            setFormData((prev) => ({ ...prev, passengers: val }));
          }}
          style={{ width: "100%", padding: "12px", marginBottom: "12px" }}
        />

{formData.passengers > 6 && formData.passengers <= 14 && (


<p className="form-minibus-note">
  🚐 For larger groups, fares are automatically adjusted for 7–14 seater minibuses.
</p>


)}



        {/* Bags */}
        <label>Bags</label>
        <input
          type="number"
          name="bags"
          placeholder={`Bags (max ${maxBags})`}
          min="0"
          max={maxBags}
          value={formData.bags}
          onChange={(e) => {
            const val = Math.min(Number(e.target.value), maxBags);
            setFormData((prev) => ({ ...prev, bags: val }));
          }}
          style={{ width: "100%", padding: "12px", marginBottom: "12px" }}
        />

        {/* 🧠 Hint when limits exceeded */}
        {(formData.passengers > maxPassengers || formData.bags > maxBags) && (
          <p style={{ color: "#d9534f", fontSize: "0.9rem", marginTop: "-8px" }}>
            Need a larger vehicle? Please contact support for a 9- or 14-seater booking.
          </p>
        )}

        <label>Pickup Time</label>
        <input
          type="datetime-local"
          value={pickupTime}
          onChange={(e) => setPickupTime(e.target.value)}
          min={new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString().slice(0, 16)}
        />




{/* Error Message */}
{errors.quote && (
  <div
    className="error-banner"
    dangerouslySetInnerHTML={{ __html: errors.quote }}
  />
)}




        {/* Get Quote Button */}
        <button
          style={{
            width: "100%",
            padding: "16px",
            backgroundColor: "#ffc107",
            color: "#000",
            fontWeight: "700",
            fontSize: "18px",
            border: "none",
            borderRadius: "6px",
            marginTop: "14px",
            cursor: "pointer",
            transition: "background 0.3s",
          }}
          onClick={getDistance}
          onMouseOver={(e) => (e.target.style.backgroundColor = "#ffb300")}
          onMouseOut={(e) => (e.target.style.backgroundColor = "#ffc107")}
        >
          {loadingQuote ? "Calculating..." : "Get Quote"}
        </button>

        {/* Display Quote */}
        {fare && !showForm && (
          <p
            style={{
              textAlign: "center",
              marginTop: "15px",
              fontWeight: "bold",
              color: "#444",
              fontSize: "18px",
            }}
          >
            Estimated Distance: <b>{distance} km</b> | Fare: <b>£{fare}</b>
            {vehicleLabel && (
              <>
                <br />
                Suggested Vehicle: <b>{vehicleLabel}</b>
              </>
            )}
          </p>
        )}

        {/* Booking Form */}
        {showForm && (
          <BookingForm
            formData={formData}
            errors={errors}
            handleInputChange={handleInputChange}
            handleSubmit={handleSubmit}
            fare={fare}
            pickupLocation={fromPostcode}
            dropoffLocation={toPostcode}
            suggestedVehicle={vehicleLabel}
          />
        )}
      </div>
  );
};

export default PostcodeQuote;
